<template>
    <div>
        <div class="resource-selector row">
            <div class="col">
                <input type="hidden" :name="formFieldName" :value="selectedFormValue">
                <multiselect :options="options"
                             @search-change="asyncQuery"
                             @select="select"
                             :internal-search="false"
                             v-model="selectedCustomer"
                             :placeholder="placeholder"
                             :loading="isLoading"
                             :preserve-search="true">
                    <template slot="singleLabel" slot-scope="{ option }">
                        <div class="row">
                            <div class="col">
                                <span>{{ option.email }}</span>
                            </div>
                        </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                        <div class="row">
                            <div class="col">
                                <span>{{ option.email }}</span>
                            </div>
                        </div>
                    </template>
                    <template slot="noResult">
                        No results found
                    </template>
                    <template slot="noOptions">
                        Start searching by typing
                    </template>
                    <pre class="language-json"><code>{{ selectedCustomer }}</code></pre>
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _ from "lodash";
import axios from "axios";
import qs from "qs";

export default {
    components: {Multiselect},
    name: "CustomerSearch",

    props: {
        placeholder: {
            default: 'Add by searching...'
        },
        formFieldName: {
            default: 'customer_uuid'
        }
    },

    data: () => {
        return {
            query: {
            },
            options: [],
            selectedCustomer: null,
            isLoading: false,
        };
    },

    computed: {
        selectedFormValue () {
            return this.selectedCustomer?.uuid;
        },
    },

    methods: {

        asyncQuery(queryString) {
            if (!queryString) {
                this.options = [];
                return;
            }

            this.isLoading = true;
            this.fetchCustomers(queryString);
        },

        fetchCustomers: _.debounce(function (queryString) {
            const stringifiedQueryString = qs.stringify({
                filters: {
                    query: queryString,
                }
            });

            axios.get(`/admin/api/customers?${stringifiedQueryString}`)
                    .then((resp) => {
                        this.isLoading = false;
                        this.options = resp.data.data;
                    })
                    .catch(() => {
                        this.isLoading = false
                    });
        }, 500),

        select(resource) {
            this.selectedCustomer = resource;
        },

        remove() {
            this.selectedCustomer = null;
        }
    }
}
</script>

<style scoped>
</style>
